// Shared constants and helpers for Slate
export const DEPT_NAMES = ['general','art','costume','casting','vfx','production','direction','sound','camera'];

export const ROLE_GRAD = {
  ADMIN: 'from-red-600 to-red-800',
  PRODUCER: 'from-[#e8c547] to-amber-700',
  DEPARTMENT_HEAD: 'from-blue-600 to-blue-800',
  DEPARTMENT_ASSISTANT: 'from-purple-600 to-purple-800',
  default: 'from-[#3a3a3a] to-[#2a2a2a]',
};

export const fmtTime = iso => {
  if (!iso) return '';
  const d = new Date(iso), now = new Date();
  const diff = now - d;
  if (diff < 60000) return 'just now';
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}h ago`;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

export const initials = name => (name || '').split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase();
export const fmtBytes = b => b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.round(b / 1024)} KB`;

export function getYouTubeId(url) {
  const m = url?.match(/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/watch\?.+&v=))([\w-]{11})/);
  return m ? m[1] : null;
}

export function photoUrl(storage_path /*, token unused */) {
  // SEC-002 (closed 2026-07-06): the legacy `?auth=<jwt>` URL is rejected.
  // Kept as a soft-deprecation stub returning an unauthenticated URL that
  // will 401 cleanly so mis-migrations surface fast. Callers should switch
  // to <AuthImage path={...} /> or the useDownloadUrl(path) hook.
  const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
  return `${API}/files?path=${encodeURIComponent(storage_path)}`;
}
